<template>
  <v-container>
    <h1>EIE Bank Accounts</h1>
    <EieBankAccountsTable
      :bank-accounts="bankAccounts"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { EieBankAccountsTable } from '@/components/eie';

export default {
  name: 'EIEBankAccounts',
  components: {
    EieBankAccountsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.eieBankAccountsStore.loading,
      bankAccounts: state => state.eieBankAccountsStore.bankAccounts,
    }),
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/eie/EieBankAccountsView.vue